import React from 'react'
import FlipToFibreRegisterForm from '../../elements/FlipToFibreRegisterForm';
import moment from 'moment';
import {useHistory } from 'react-router-dom';

const SqMessage = (props) => {
    
    const { hasError, sqResult, address } = props;

    let history = useHistory();

    const handleHideResults = (id, e) => {
        e.preventDefault();
        props.handleHideResults();
        scrollWithOffset(id);
    }

    const scrollWithOffset = (id) => {
        const plans = document.getElementById(id);
        window.scroll({ top: plans.offsetTop - 200, behavior: 'smooth' });
    }
     
    /* To check if the sq is able to flip to fibre by any chance. If false, never flip-to-fibre, then show error message. */
    const checkIfFlipToFibreAvailable = () => {
        const serviceClasses = [10, 11, 12, 13, 30, 31, 32, 33, 34];
        const nbnServiceClass = parseInt(sqResult.sqClass);
        return serviceClasses.includes(nbnServiceClass);
    }

    const AddressNotAvailableMessage = (response) => {
        if (response.maxSpeed === 0 || !response.services.includes('nbn')) {
            return (
                <p className="px-4 py-3">
                    Unfortunately we are unable to provide a service to your address. You may wish to try an alternative supplier. Thanks for visiting Exetel.
                </p>
            )
        }
    }

    const FlipToFibreResponseMessage = (response) => {
        const FlipToFibreAvailable = () => {
            return (
                <div className="px-lg-5 px-3 py-3">
                    <p className="text-center m-0">
                        Great news, your address can be <span className="bold color-lime">upgraded</span> from {moment(sqResult.flipDate).format("DD MMM YYYY")}. <br />
                        As a new Exetel customer, choose your interim nbn™ plan below. We’ll immediately transfer your internet service to Exetel and upgrade your connection for <span className="bold color-lime">FREE</span> asap.
                    </p>
                    <button className="view-plans-btn mt-4" onClick={e => handleHideResults('f2f-plans', e)}>View plans</button>
                </div>
            )
        }
        

        if (!response.flipReady && checkIfFlipToFibreAvailable() && props.isOnFlipToFibre || response.flipReady && !response.flipDate && props.isOnFlipToFibre) {
            return (
                <div className="px-lg-5 px-3 py-3">
                    <p className="text-center mt-0">
                        Your address is currently connected via <span className="bold color-lime" dangerouslySetInnerHTML={{__html: `${response.nbnType}`}} />. <br className="d-none d-lg-inline" />
                        Unfortunately, NBN Co have not yet scheduled a date when your address will be <br className="d-none d-lg-inline" />
                        <span className="bold color-lime">Fibre-to-the-fibre </span>upgrade ready.
                    </p>
                    <FlipToFibreRegisterForm sqAddress={address} handleHideResults={props.handleHideResults} />
                </div>
            )
        }

        if (!response.flipReady && !checkIfFlipToFibreAvailable() && !response.flipDate && props.isOnFlipToFibre) {
            return (
                <div className="col-12 px-3 px-lg-5 my-4">                    
                    <p>Your address is connected to <span className="bold color-lime" dangerouslySetInnerHTML={{ __html: `${response.nbnType}`}} /> and unfortunately doesn’t qualify for our Flip to Fibre™ promotion. Instead you can choose one of our great value nbn™ plans from $65/mth. </p>
                    <button className="view-plans-btn" onClick={() => history.push('small-business/nbn')}>View plans</button>
                </div>
            )
        }

        if (response.flipReady && response.flipDate && checkIfFlipToFibreAvailable()) {
            return FlipToFibreAvailable();
        }
    }

    const FlipToFibreAvailableNbn = (response) => {
        return (
            <div className="col-12 pt-5 px-3 px-lg-5">
                <p className="my-2 font-medium">
                    Good news, your address is currently connected via nbn&trade; <span className="color-lime bold" dangerouslySetInnerHTML={{ __html: response.nbnType }} />. You can also choose to upgrade now and Flip to Fibre™ with a <span className="color-lime bold">FREE Fibre-to-the-home</span> connection upgrade
                </p>
                <div className="mt-lg-5 mt-3">
                    <div className="action-row d-flex mb-3 align-items-center">
                        <button className="text-center mr-3 view-plans-btn btn-custom" onClick={() => history.push('/flip-to-fibre')}>Upgrade now</button>
                        <p className="font-small text-lg-left text-center m-0">Choose a <span className="color-lime bold">new high speed nbn™ plan</span> up to <span className="color-lime bold">500Mbps</span> and order your <span className="color-lime bold">FREE upgrade now.</span>  We’ll sort the rest, and keep you posted every step of the way. </p>
                    </div>
                    <div className="action-row d-flex mb-3 align-items-center">
                        <button className="text-center mr-3 btn-grey btn btn-custom view-plans-btn" onClick={e => handleHideResults('nbn-plan-container', e)}>Skip upgrade</button>
                        <p className="font-small text-lg-left text-center m-0">No thanks, I’d like to choose an <span className="color-lime bold">Exetel FTTN</span> plan up and get connected asap.</p>
                    </div>
                </div>
            </div>
        )
    }

    const nbnResult = (response) => {
        if (response.flipReady && response.flipDate) {
            return FlipToFibreAvailableNbn(response);
        }

        return (
            <div className="px-lg-5 px-3 py-3">
                <p>
                    Great! A {response.nbnType} nbn&trade; service is available at your address. Select your plan below:
                </p>
                <button className="view-plans-btn mt-4" onClick={e => handleHideResults('nbn-plan-container', e)}>View plans</button>
            </div>
        )
    }

    if (hasError) {
        return (
            <div className="col-12 px-lg-5 p-4 sqMessage">            
                <a className="close-btn" onClick={props.handleHideResults}>
                    <img src="/images/icon-close-indigo.svg" />
                </a>
                <p className="row-error">
                    Oops, something went wrong. Please check the spelling of your address and try again.
                </p>
                <p className='row-error'>Unfortunately, we were unable to find your address. Please call us on <a className='color-lime' href='tel: 133938'>13 39 38</a></p>
            </div>
        )
    }

    return (
        <div className="col-12 px-lg-5 p-4 p-sm-2 sqMessage">
            {
                !sqResult.services.includes('nbn') || sqResult.maxSpeed === 0 ? AddressNotAvailableMessage(sqResult) : (props.isOnFlipToFibre ? FlipToFibreResponseMessage(sqResult) : nbnResult(sqResult))
            }
        </div>
    )
}

export default SqMessage


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/sqField/SqMessage.js